export const convertContentToPlainText = (content) => {
  if (!content) return '';

  if (Array.isArray(content)) {
    return content
      .map(block => {
        if (typeof block === 'string') {
          return block;
        }

        if (typeof block === 'object' && block.content) {
          return block.content;
        }

        return '';
      })
      .filter(text => text && text.trim().length > 0)
      .join('. ');
  }

  if (typeof content === 'string') {
    return content
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  return '';
};

export const buildArticleTTSContent = (article) => {
  if (!article) return '';

  const parts = [];
  if (article.title) parts.push(article.title);

  const infoParts = [];
  if (article.siteName) infoParts.push(`Fonte: ${article.siteName}`);

  const dateToFormat = article.date || article.publishedAt || article.createdAt;
  if (dateToFormat) {
    const dateStr = new Date(dateToFormat).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC'
    });
    infoParts.push(`Data: ${dateStr}`);
  }

  if (infoParts.length > 0) parts.push(infoParts.join('. '));
  if (article.description) parts.push(`Resumo: ${article.description}`);

  const plainTextContent = convertContentToPlainText(article.content);
  if (plainTextContent && plainTextContent !== article.description) {
    parts.push(`Conteúdo: ${plainTextContent}`);
  }

  return parts.join('. ');
};
